var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1102,
    height: 1584,
    viewBox: "0 0 1102 1584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.601 652.568L255.535 568.7C327.212 506.684 357.673 409.478 334.207 317.647C311.575 229.079 339.067 135.219 405.908 72.8584L484 0H1102V904V1056.35C1102 1323.66 902.067 1548.73 636.615 1580.24C430.267 1604.74 228.759 1505.83 121.922 1327.6L65.5724 1233.59C-48.6589 1043.03 -9.41686 797.939 158.601 652.568Z",
    fill: "#A7ACDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorShape);
export default __webpack_public_path__ + "static/media/VectorShape.5249e975333c5b2c6e3de0985af5e5cc.svg";
export { ForwardRef as ReactComponent };